const TAG_ID_RE = /^[A-Za-z0-9_-]+$/;
const EVENT_NAME_RE = /^[A-Za-z0-9_]+$/;

/** tagIds that have already received gtag('js') + gtag('config'). */
const configuredTagIds = new Set();

const isProd = () =>
  undefined !== process.env.REACT_APP_ENV &&
  process.env.REACT_APP_ENV.startsWith("prod");

const ensureGtag = () => {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  return window.gtag;
};

const loadGtagScript = (tagId) => {
  const src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(tagId)}`;
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }
  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
};

/**
 * Build a plain object for gtag('event', …) from partner eventData + source map.
 * Substitutes %KEY% placeholders with JSON-safe values and parses JS-literal-style objects.
 * Returns null when a non-empty string eventData cannot be parsed (caller should skip the event).
 */
const buildEventParams = (eventData, source) => {
  if (eventData && typeof eventData === "object" && !Array.isArray(eventData)) {
    const params = { ...eventData };
    if (source) {
      Object.keys(source).forEach((key) => {
        const placeholder = `%${key.toUpperCase()}%`;
        Object.keys(params).forEach((paramKey) => {
          if (params[paramKey] === placeholder) {
            params[paramKey] =
              source[key] === undefined ? null : source[key];
          }
        });
      });
    }
    return params;
  }

  if (eventData == null || eventData === "") {
    return {};
  }

  if (typeof eventData !== "string") {
    return null;
  }

  if (!eventData.trim()) {
    return {};
  }

  let data = eventData;
  if (source) {
    Object.keys(source).forEach((key) => {
      const placeholder = `%${key.toUpperCase()}%`;
      const replacement =
        source[key] === undefined ? "null" : JSON.stringify(source[key]);
      data = data.split(`'${placeholder}'`).join(replacement);
      data = data.split(`"${placeholder}"`).join(replacement);
      data = data.split(placeholder).join(replacement);
    });
  }

  // Normalize common single-quoted object literals from partner config to JSON.
  const asJson = data
    .replace(/([{,]\s*)'([^']+)'(\s*:)/g, '$1"$2"$3')
    .replace(/:\s*'([^']*)'/g, (_, value) => `: ${JSON.stringify(value)}`);

  try {
    const parsed = JSON.parse(asJson);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
};

export const addGtag = (trackCode) => {
  if (
    !document.head ||
    !trackCode ||
    !trackCode.tagId ||
    !isProd() ||
    !TAG_ID_RE.test(trackCode.tagId)
  ) {
    return;
  }

  const tagId = trackCode.tagId;
  loadGtagScript(tagId);

  if (configuredTagIds.has(tagId)) {
    return;
  }
  configuredTagIds.add(tagId);

  const gtag = ensureGtag();
  gtag("js", new Date());
  gtag("config", tagId);
};

export const addGtagEvent = (trackCode, source) => {
  if (
    !document.head ||
    !trackCode ||
    !trackCode.eventName ||
    !EVENT_NAME_RE.test(trackCode.eventName)
  ) {
    return;
  }

  const params = buildEventParams(trackCode.eventData, source);
  // Non-empty string eventData that failed to parse — skip rather than fire empty {}.
  if (params === null) {
    return;
  }
if(!isProd()) {
    console.log("event", trackCode.eventName, JSON.stringify(params));
    return;
  }else{
  const gtag = ensureGtag();
  gtag("event", trackCode.eventName, params);
}
};
